 import axios from 'axios';

// Base API configuration
const API_URL = process.env.REACT_APP_API_URL || 'http://15.235.198.107:3005';

// Create axios instance
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Common error handling function
const handleApiError = (error) => {
  console.error('API Error:', error);
  
  if (error.response) {
    // Server responded with an error
    throw error.response.data || new Error('An error occurred');
  } else if (error.request) {
    // Request made but no response received
    throw new Error('No response from server');
  } else {
    // Error setting up the request
    throw error;
  }
};

// Explicitly export each function
export function createIdea(ideaData) {
  return api.post('/idea', ideaData)
    .then(response => response.data)
    .catch(handleApiError);
}

export function fetchIdeas(options = {}) {
  const { 
    page = 1, 
    limit = 10, 
    sort = 'recent', // Default to most recent
    tag 
  } = options;
  
  // Validate sort parameter
  const validSortOptions = ['recent', 'most_upvoted', 'most_commented'];
  const sanitizedSort = validSortOptions.includes(sort) ? sort : 'recent';
  
  return api.get('/idea', {
    params: { 
      page, 
      limit, 
      sort: sanitizedSort, 
      tag 
    }
  })
    .then(response => {
      // Ensure we return data with default empty array
      return response.data.data || [];
    })
    .catch(handleApiError);
}

export const getIdeaById = async (ideaId) => {
  try {
    // Validate input
    if (!ideaId) {
      throw new Error('Invalid idea ID');
    }
    
    const response = await api.get(`/idea/${ideaId}`);
    
    // Ensure response has data
    if (!response.data) {
      throw new Error('No idea found');
    }
    
    return response.data.idea || response.data;
  } catch (error) {
    console.error('Get idea error:', error);
    
    if (error.response) {
      // Server responded with an error
      throw error.response.data || new Error('Failed to get idea');
    } else if (error.request) {
      // Request made but no response received
      throw new Error('No response from server');
    } else {
      // Error setting up the request
      throw error;
    }
  }
};

export const voteOnIdea = async (ideaId, voteType) => {
  try {
    const response = await api.post(`/idea/${ideaId}/vote`, { voteType });
    return response.data;
  } catch (error) {
    console.error('Vote on idea error:', error);
    
    // More detailed error handling
    if (error.response) {
      console.error('Server error:', error.response.data);
      throw error.response.data;
    } else if (error.request) {
      console.error('No response:', error.request);
      throw new Error('No response from server');
    } else {
      console.error('Error', error.message);
      throw error;
    }
  }
};

export function watchIdea(ideaId, watch = true) {
  return api.post(`/idea/${ideaId}/watch`, { watch })
    .then(response => response.data)
    .catch(handleApiError);
}

// Default export for compatibility
const ideaService = {
  createIdea,
  fetchIdeas,
  getIdeaById,
  voteOnIdea,
  watchIdea
};

export default ideaService;
